import { render, staticRenderFns } from "./modal-didtributor.vue?vue&type=template&id=f6024da6&"
import script from "./modal-didtributor.vue?vue&type=script&lang=js&"
export * from "./modal-didtributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports